import React from 'react'
import Link from 'gatsby-link'
import NavTitle from '../components/nav-title'
import Section from '../components/section'
import ExternalLink from '../components/external-link'
import styled from 'styled-components'
import { posts, projects } from '../content.json'

const UnorderedList = styled.ul`
  list-style-type: none;
  padding: 0;
  margin: 0;
`

const ListItem = styled.li`margin: 1rem 0;`

const Datum = styled.span`
  font-size: 0.75rem;
  display: block;
  padding-top: 0.25rem;
`

const Description = Datum

const More = styled.p`
  font-size: 0.85rem;
  color: #b8b8b8;
  padding-top: 1rem;
`

const Wrapper = styled.div`
  display: flex;

  @media (max-width: 960px) {
    flex-direction: column;
  }
`

export default () => (
  <Wrapper>
    <Section>
      <NavTitle>Hello!</NavTitle>
      <p>This is my website. It is a bit empty at the moment, but feel free to look around!</p>
    </Section>

    <Section>
      <NavTitle>My Latest Projects</NavTitle>
      <nav>
        <UnorderedList>
          {projects.map(({ id, title, description, url }) => (
            <ListItem key={id}>
              <ExternalLink to={url}>{title}</ExternalLink>
              <Description>{description}</Description>
            </ListItem>
          ))}
        </UnorderedList>
      </nav>
      <More>More projects on my Github and Gitlab pages.</More>
    </Section>
  </Wrapper>
)



// WEBPACK FOOTER //
// ./src/pages/index.js